module.exports = __webpack_public_path__ + "img/vms_ico_3.b45fc4a7.svg";